const BACKGROUND_CHECK_ERROR_MESSAGE = "You can't work as you don't have a valid background check.";

export function isBackgroundCheckError(error: unknown) {
  return error instanceof Error && error.message === BACKGROUND_CHECK_ERROR_MESSAGE;
}
